import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { CmsConfig } from '@spartacus/core';
import { provideDefaultConfig } from '../../../core/config';
import { CatalogProductListItemModule, PipesModule } from '../../../shared';
import { MediaIconModule } from '../../../shared/components/media-icon';
import { ProductCarouselModule } from '../../../shared/components/product-carousel';
import { ProductsTilesComponent } from './products-tiles.component';

@NgModule({
  imports: [CommonModule, MediaIconModule, PipesModule, ProductCarouselModule, CatalogProductListItemModule],
  providers: [
    provideDefaultConfig(<CmsConfig>{
      cmsComponents: {
        ProductsTileComponent: {
          component: ProductsTilesComponent,
        },
      },
    }),
  ],
  declarations: [ProductsTilesComponent],
  exports: [ProductsTilesComponent],
})
export class CmsProductsTileModule {}
